import { ReactComponent as PhoneIcon } from "./svg/phone.svg";
import "./IconActionPhone.scss";

export const IconActionPhone = () => {
  return (
    <span className="icon-action-phone" aria-hidden="true">
      <PhoneIcon />
    </span>
  );
};
